import { useState, useEffect } from 'react';
import axios from 'axios';
import { HiX } from 'react-icons/hi';

const API = process.env.REACT_APP_API_URL;

export default function NewsletterPopup() {
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');
  const [subscribing, setSubscribing] = useState(false);   // ← NEW

  // Show popup after 5 seconds, only once per session
  useEffect(() => {
    const shown = sessionStorage.getItem('newsletterShown');
    if (!shown) {
      const timer = setTimeout(() => {
        setOpen(true);
        sessionStorage.setItem('newsletterShown', 'true');
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || subscribing) return;   // block double‑click

    setError('');
    setSubscribing(true);

    try {
      await axios.post(`${API}/api/newsletter/subscribe`, { email });
      setSubmitted(true);
    } catch (err) {
      setError('Something went wrong. Please try again.');
    } finally {
      setSubscribing(false);
    }
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 z-50 flex items-center justify-center p-4">
      <div className="bg-white max-w-md w-full p-8 relative">
        <button
          onClick={() => setOpen(false)}
          className="absolute top-3 right-3 text-gray-400 hover:text-black"
        >
          <HiX size={20} />
        </button>

        {!submitted ? (
          <div className="text-center">
            <h3 className="text-2xl font-bold mb-2">Join the Wave</h3>
            <p className="text-gray-600 mb-6 text-sm">
              Get 10% off your first order + early access to drops.
            </p>
            <form onSubmit={handleSubmit} className="flex flex-col gap-3">
              <input
                type="email"
                placeholder="Your email"
                className="border border-gray-300 p-3 w-full focus:outline-none focus:border-black"
                value={email}
                onChange={e => setEmail(e.target.value)}
                required
              />
              <button
                type="submit"
                disabled={subscribing}   // ← disabled while subscribing
                className="bg-black text-white py-3 font-semibold hover:bg-gray-800 transition disabled:opacity-50"
              >
                {subscribing ? 'Subscribing…' : 'SIGN UP'}
              </button>
            </form>
            {error && <p className="text-red-500 text-sm mt-2">{error}</p>}
            <button
              onClick={() => setOpen(false)}
              className="text-gray-400 text-sm mt-4 underline"
            >
              No thanks
            </button>
          </div>
        ) : (
          <div className="text-center py-8">
            <h3 className="text-2xl font-bold mb-2">You're in!</h3>
            <p className="text-gray-600">Check your inbox for a welcome gift.</p>
          </div>
        )}
      </div>
    </div>
  );
}